import Notification from '../../components/Notification/Notification';
import responseCodes from '../../constants/responseCodes';
import i18n from '../../i18n';
import history from '../../routing/history';
import urls from '../../routing/urls';
import * as integrationService from '../../services/integrationService';
import globalActionConstants from '../constants/globalActionConstants';
import integrationActionConstants from '../constants/integrationActionConstants';

const t = (key) => i18n.t(key, { ns: 'common' });

export const authorizeToSlack = (code) => async () => {
  try {
    const response = await integrationService.authorizeSlack(code);
    if (response.data.response_code === responseCodes.OK) {
      Notification.success(response.data.message);
    } else {
      Notification.error(response.data.error);
    }

    history.push(urls.slackIntegration);
  } catch (error) {
    Notification.error(error.message);
  }
};

export const getIntegrationSettings = (organizationId) => async (dispatch) => {
  dispatch({ type: integrationActionConstants.GET_INTEGRATION });

  try {
    const response = await integrationService.getIntegrationSettings(organizationId);
    if (response.data.response_code === responseCodes.OK) {
      return dispatch({
        type: integrationActionConstants.GET_INTEGRATION_SUCCESS,
        payload: response.data.payload.organizations,
      });
    }
  } catch (error) {
    dispatch({ type: integrationActionConstants.GET_INTEGRATION_ERROR, payload: error.response.data.error });
  }
};

export const getSlackAuthoriztions = () => async (dispatch) => {
  dispatch({ type: integrationActionConstants.GET_SLACK_AUTHORIZATION });

  try {
    const response = await integrationService.getSlackAuthoriztions();
    if (response.data.response_code === responseCodes.OK) {
      return dispatch({
        type: integrationActionConstants.GET_SLACK_AUTHORIZATION_SUCCESS,
        payload: response.data.payload,
      });
    }
  } catch (error) {
    dispatch({ type: integrationActionConstants.GET_SLACK_AUTHORIZATION_ERROR, payload: error.response.data.error });
  }
};

export const updateSlackUser = (slackUserId, setReferStatus, referStatus) => async (dispatch) => {
  dispatch({ type: integrationActionConstants.UPDATE_SLACK_USER });

  try {
    const response = await integrationService.updateSlackUser(slackUserId, referStatus);
    if (response.data.response_code === responseCodes.OK) {
      setReferStatus(referStatus === 'mute' ? 'muted' : referStatus);
      return dispatch({
        type: integrationActionConstants.UPDATE_SLACK_USER_SUCCESS,
        payload: response.data.payload,
      });
    }
  } catch (error) {
    dispatch({ type: integrationActionConstants.UPDATE_SLACK_USER_ERROR, payload: error.response.data.error });
  }
};

export const postIntegrationRequest = (data, cb) => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });
  try {
    const response = await integrationService.postIntegrationRequest(data);
    if (response.data.response_code === responseCodes.OK) {
      Notification.success(t('notifications.integrationRequestSubmitted'));
      return cb?.();
    }
    Notification.error(response.data.error.message || response.data.error);
  } catch {
    Notification.error(t('notifications.somethingWentWrong'));
  } finally {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
  }
};

export const getLinkedinAccounts = () => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });

  try {
    const response = await integrationService.getIntegrationAccounts('linkedin');
    if (response.data.response_code === responseCodes.OK) {
      dispatch({ type: integrationActionConstants.GET_LINKEDIN_ACCOUNTS, payload: response.data.payload });
    } else {
      Notification.error(response.data.error);
    }
  } catch {
    Notification.error(t('notifications.somethingWentWrong'));
  } finally {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
  }
};

export const addLinkedInAccount = (redirectPath) => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });

  try {
    const response = await integrationService.addLinkedInAccount(redirectPath);
    if (response.data.response_code === responseCodes.OK) {
      setTimeout(() => {
        window.open(response.data.payload, '_blank');
      }, 100);
    } else {
      Notification.error(response.error.message || response.data.error);
    }
  } catch {
    Notification.error(t('notifications.somethingWentWrong'));
  } finally {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
  }
};

export const linkedInAuthentication = (linkedInCode, redirectPath, cb) => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });

  try {
    const response = await integrationService.linkedInAuthentication(linkedInCode, redirectPath);
    if (response.data.response_code === responseCodes.OK) {
      dispatch(getLinkedinAccounts());
      cb();
      Notification.success(t('notifications.linkedinAccountAdded'));
    } else {
      Notification.error(response.data.error);
    }
  } catch {
    Notification.error(t('notifications.somethingWentWrong'));
  } finally {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
  }
};

export const disconnectIntegration = (id) => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });

  try {
    const response = await integrationService.deleteIntegrationAccount(id);
    if (response.data.response_code === responseCodes.OK) {
      Notification.success(t('notifications.accountDisconnected'));
      dispatch({ type: integrationActionConstants.DISCONNECT_LINKEDIN_ACCOUNT, payload: id });
    } else {
      Notification.error(response.data.error);
    }
  } catch {
    Notification.error(t('notifications.somethingWentWrong'));
  } finally {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
  }
};
